import { AxiosPlugin } from "@products/base-portal-lib/plugins";

export default defineNuxtPlugin({
	name: "axios",
	order: 1010,
	setup: (nuxtApp) => {
		const config = useRuntimeConfig();

		nuxtApp.vueApp.use(AxiosPlugin, {
			baseURL: config.public.API_URL,
		});
	},
});
